export const ENVIRONMENT = {
  name: 'tkprod',
  apiHkcApiName: 'tkprod',
  apiHkcInsightsName: 'tkprod',
  isProduction: true,
  fullName: 'Production',
  color: '#22c55e',
  appName: 'Insight Engine UI',
  oktaGroups: {
    campaign_manager: 'LCM-Insight_Engine-TKprod_Campaign_Manager',
    qa: 'LCM-Insight_Engine-TKprod_QA_Tester',
    promoter: '',
    drb_user: 'LCM-Insight_Engine-DRB_User',
    drb_manager: 'LCM-Insight_Engine-DRB_Manager'
  },
  bundleNames: []
};

export const CONFIG = {
  aws_project_region: 'ap-northeast-1',
  aws_cognito_region: 'ap-northeast-1',
  aws_user_pools_id: 'ap-northeast-1_EKSFpfkSw',
  aws_user_pools_web_client_id: '4j81d2dg7a743v7tboe2opnfab',
  aws_cognito_identity_pool_id: 'ap-northeast-1:16c2cb94-1050-47e5-b577-90b445e01365',
  API: {
    endpoints: [
      {
        name: 'campaigns_api',
        host: '9tkiswcylb.execute-api.ap-northeast-1.amazonaws.com',
        endpoint: 'https://9tkiswcylb.execute-api.ap-northeast-1.amazonaws.com',
        path: '/{stage}/campaigns',
        protocol: 'https',
        methods: ['GET', 'POST', 'DELETE'],
        url: 'https://9tkiswcylb.execute-api.ap-northeast-1.amazonaws.com/{stage}/campaigns'
      },
      {
        name: 'cleaning_estimates_api',
        host: 'rrytk7alg4.execute-api.ap-northeast-1.amazonaws.com',
        endpoint: 'https://rrytk7alg4.execute-api.ap-northeast-1.amazonaws.com',
        path: '/{stage}/insights/qa/cleaning-estimates',
        protocol: 'https',
        methods: ['POST'],
        url: 'https://rrytk7alg4.execute-api.ap-northeast-1.amazonaws.com/{stage}/insights/qa/cleaning-estimates'
      },
      {
        name: 'robots_api',
        host: 'rrytk7alg4.execute-api.ap-northeast-1.amazonaws.com',
        endpoint: 'https://rrytk7alg4.execute-api.ap-northeast-1.amazonaws.com',
        path: '/{stage}/insights/qa/robots',
        protocol: 'https',
        methods: ['GET', 'POST', 'DELETE'],
        url: 'https://rrytk7alg4.execute-api.ap-northeast-1.amazonaws.com/{stage}/insights/qa/robots'
      },
      {
        name: 'notifications_api',
        host: 'rrytk7alg4.execute-api.ap-northeast-1.amazonaws.com',
        endpoint: 'https://rrytk7alg4.execute-api.ap-northeast-1.amazonaws.com',
        path: '/{stage}/campaigns/qa/notifications',
        protocol: 'https',
        methods: ['POST'],
        url: 'https://rrytk7alg4.execute-api.ap-northeast-1.amazonaws.com/{stage}/campaigns/qa/notifications'
      },
      {
        name: 'insights_api',
        host: 'vc60gfkeo5.execute-api.ap-northeast-1.amazonaws.com',
        endpoint: 'https://vc60gfkeo5.execute-api.ap-northeast-1.amazonaws.com',
        path: '/{stage}/registrations',
        protocol: 'https',
        methods: ['GET', 'POST', 'DELETE'],
        url: 'https://vc60gfkeo5.execute-api.ap-northeast-1.amazonaws.com/{stage}/registrations'
      },
      {
        name: 'content_api',
        host: 'aoy3f4vzu6.execute-api.ap-northeast-1.amazonaws.com',
        endpoint: 'https://aoy3f4vzu6.execute-api.ap-northeast-1.amazonaws.com',
        path: '/{stage}/content',
        protocol: 'https',
        methods: ['GET', 'POST', 'PUT'],
        url: 'https://aoy3f4vzu6.execute-api.ap-northeast-1.amazonaws.com/{stage}/content'
      },
      {
        name: 'single_content_api',
        host: 'aoy3f4vzu6.execute-api.ap-northeast-1.amazonaws.com',
        endpoint: 'https://aoy3f4vzu6.execute-api.ap-northeast-1.amazonaws.com',
        path: '/{stage}/content/{contentKey}',
        protocol: 'https',
        methods: ['GET', 'POST', 'DELETE'],
        url: 'https://aoy3f4vzu6.execute-api.ap-northeast-1.amazonaws.com/{stage}/content/{contentKey}'
      },
      {
        name: 'content_templates_api',
        host: 'aoy3f4vzu6.execute-api.ap-northeast-1.amazonaws.com',
        endpoint: 'https://aoy3f4vzu6.execute-api.ap-northeast-1.amazonaws.com',
        path: '/{stage}/content/templates',
        protocol: 'https',
        methods: ['GET', 'POST', 'DELETE'],
        url: 'https://aoy3f4vzu6.execute-api.ap-northeast-1.amazonaws.com/{stage}/content/templates'
      },
      {
        name: 'surveys_api',
        host: '26f641gmu0.execute-api.ap-northeast-1.amazonaws.com',
        endpoint: 'https://26f641gmu0.execute-api.ap-northeast-1.amazonaws.com',
        path: '/{stage}/surveys',
        protocol: 'https',
        methods: ['GET', 'POST'],
        url: 'https://26f641gmu0.execute-api.ap-northeast-1.amazonaws.com/{stage}/surveys'
      },
      {
        name: 'responses_api',
        host: '26f641gmu0.execute-api.ap-northeast-1.amazonaws.com',
        endpoint: 'https://26f641gmu0.execute-api.ap-northeast-1.amazonaws.com',
        path: '/{stage}/surveys/responses',
        protocol: 'https',
        methods: ['GET'],
        url: 'https://26f641gmu0.execute-api.ap-northeast-1.amazonaws.com/{stage}/surveys/responses'
      },
      {
        name: 'single_survey_api',
        host: '26f641gmu0.execute-api.ap-northeast-1.amazonaws.com',
        endpoint: 'https://26f641gmu0.execute-api.ap-northeast-1.amazonaws.com',
        path: '/{stage}/surveys/{survey_id}',
        protocol: 'https',
        methods: ['GET'],
        url: 'https://26f641gmu0.execute-api.ap-northeast-1.amazonaws.com/{stage}/surveys/{survey_id}'
      },
      {
        name: 'campaign_deliveries_api',
        endpoint: 'https://9tkiswcylb.execute-api.ap-northeast-1.amazonaws.com',
        path: '/{stage}/deliveries',
        protocol: 'https',
        methods: ['GET'],
        url: 'https://9tkiswcylb.execute-api.ap-northeast-1.amazonaws.com/{stage}/deliveries'
      },
      {
        name: 'jobs_api',
        endpoint: 'https://79ibtesr2k.execute-api.ap-northeast-1.amazonaws.com',
        path: '/{stage}/jobs/',
        protocol: 'https',
        methods: ['GET'],
        url: 'https://79ibtesr2k.execute-api.ap-northeast-1.amazonaws.com/{stage}/jobs'
      },
      {
        name: 'single_jobs_api',
        endpoint: 'https://79ibtesr2k.execute-api.ap-northeast-1.amazonaws.com',
        path: '/{stage}/jobs/{job_id}',
        protocol: 'https',
        methods: ['GET', 'DELETE'],
        url: 'https://79ibtesr2k.execute-api.ap-northeast-1.amazonaws.com/{stage}/jobs/{job_id}'
      },
      {
        name: 'campaign_job_api_start',
        endpoint: 'https://79ibtesr2k.execute-api.ap-northeast-1.amazonaws.com',
        path: '/{stage}/jobs/campaigns/{campaign_id}',
        protocol: 'https',
        methods: ['POST'],
        url: 'https://79ibtesr2k.execute-api.ap-northeast-1.amazonaws.com/{stage}/jobs/campaigns/{campaign_id}'
      },
      {
        name: 'insight_job_api_start',
        endpoint: 'https://79ibtesr2k.execute-api.ap-northeast-1.amazonaws.com',
        path: '/{stage}/jobs/insights/{insight_id}',
        protocol: 'https',
        methods: ['POST'],
        url: 'https://79ibtesr2k.execute-api.ap-northeast-1.amazonaws.com/{stage}/jobs/insights/{insight_id} '
      },
      {
        name: 'web_socket',
        endpoint: 'wss://6m3rdmxt3c.execute-api.ap-northeast-1.amazonaws.com/prod'
      },
      {
        name: 'get-failed-jobs',
        endpoint: 'https://79ibtesr2k.execute-api.ap-northeast-1.amazonaws.com',
        path: '/{stage}/jobs/get-failed-jobs',
        protocol: 'https',
        methods: ['GET'],
        url: 'https://79ibtesr2k.execute-api.ap-northeast-1.amazonaws.com/{stage}/jobs/get-failed-jobs '
      },
      {
        name: 'maps_api',
        endpoint: 'https://rrytk7alg4.execute-api.ap-northeast-1.amazonaws.com',
        path: '/{stage}/',
        protocol: 'https',
        methods: ['GET'],
        url: 'https://rrytk7alg4.execute-api.ap-northeast-1.amazonaws.com/{stage}/'
      }
    ]
  },
  oauth: {
    domain: 'insight-engine-tkprod.auth.ap-northeast-1.amazoncognito.com',
    scope: ['email', 'openid', 'profile'],
    redirectSignIn: 'https://engine.app.insights-tkprod.data.irobotapi.com/callback',
    redirectSignOut: 'https://engine.app.insights-tkprod.data.irobotapi.com/signout',
    responseType: 'code'
  },
  federationTarget: 'COGNITO_USER_POOLS'
};
